module.exports = __webpack_public_path__ + "static/media/footer-spritesheet-dark.2852a3cc.png";